import React from 'react';
import { Link } from 'react-router-dom';
import Loading from '../Loading';
import Routes from '../../Shared/routes';
import { StoreObjectCategory } from '../../Entities/StoreObjectCategory';


interface IProps {
    list: StoreObjectCategory[];
    remove: (rId: number) => void;
    add: () => void;
    isLoading: boolean;
}

export default class StoreObjectCategoryList extends React.Component<IProps> {

    onAdd = () => {
        this.props.add();
    }

    onRemove = (id: number | undefined) => {
        if (id) {
            this.props.remove(id);
        }
    }

    renderItem = (item: StoreObjectCategory) => {
        return (
            <tr>
                <td>{item.getId()}</td>
                <td>{item.name}</td>
                <td>
                    <Link to={`${Routes.STORE_OBJECT_CATEGORY_EDIT}/${item.getId()}`}>Редактировать</Link><br />
                    <a href="#" onClick={() => this.onRemove(item.getId())}>Удалить</a>
                </td>
            </tr>
        )
    }

    render() {
        const { isLoading, list } = this.props;
        if (isLoading) {
            return <Loading />;
        }
        else {
            return (
                <>

                    <div className="app-title">
                        <div>
                            <h1><i className="fa fa-th-list"></i> Категории салонов</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <div className="tile">
                                <button
                                    onClick={this.onAdd}
                                    className="btn btn-primary"
                                    type="submit">Добавить категорию</button>
                                <br />
                                <br />
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Название</th>
                                            <th>Действия</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map(this.renderItem)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    }
}